import React from 'react';
import { DateInput, FormCell, Select, TextInput } from 'ui-toolkit';
import generateHOAFeesOptions from '../utilities/generateHOAFeesOptions';
import partsFromDate, { generateDateText } from '../utilities/partsFromDate';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import IItemProps from './IItemProps';
import ItemMetaDataModal, { IItemMetaDataModalRef } from './ItemMetaDataModal/ItemMetaDataModal';
import SharedItemCells from './SharedItemCells';
import './_HOA.scss';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { transformLabelValueToValue } from '../utilities/transformLabelValueToValue';
import { transformDateInputToValue } from '../utilities/transformDateInputToValue';
import { IHOAFeeViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

const hoaFeesAsOptions = generateHOAFeesOptions();

interface IHOAFeeProps
  extends IItemProps,
    IHasItemDataProps<IHOAFeeViewItem>,
    Required<IHasItemEventProps<IHOAFeeViewItem>>,
    IHasMetaDataModalProps {}

type IHOAFeeState = IHasMetaDataModalState;

export default class HOAFee extends React.Component<IHOAFeeProps, IHOAFeeState> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IItemMetaDataModalRef>();

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const { sub_type, payee, date_to } = data;
    const toDate = partsFromDate(date_to);
    const selectedHOAFeeOption = hoaFeesAsOptions.find((option) => option.value === sub_type);
    const isSubtypeLocked = !data.new && !!selectedHOAFeeOption;

    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const payeeOnChange = generateDefaultOnChangeHandler('payee');
    const hoaFeeOptionOnChange = generateDefaultOnChangeHandler('sub_type', transformLabelValueToValue);
    const paidThroughOnChange = generateDefaultOnChangeHandler('date_to', transformDateInputToValue);

    return (
      <div className="hoa">
        <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
          <ItemMetaDataModal
            expanded={this.state.expanded}
            label={
              <span>
                {selectedHOAFeeOption ? `${selectedHOAFeeOption.label} ` : ''}
                {payee ? `to ${payee} ` : ''}
                {toDate ? `Pd Through ${generateDateText(toDate)}` : ''}
              </span>
            }
            onToggle={this.onModalToggleEvent}
            ref={this.modal}
          >
            <div className="hoa__modal">
              <FormCell label="Sub Type" wrapInput={!isSubtypeLocked}>
                {isSubtypeLocked ? (
                  <span>{selectedHOAFeeOption!.label}</span>
                ) : (
                  <Select
                    options={hoaFeesAsOptions}
                    autoFocus={true}
                    value={selectedHOAFeeOption}
                    onChange={hoaFeeOptionOnChange}
                    onBlur={this.onBlurEvent}
                    isDisabled={!hasEditPermissions}
                  />
                )}
              </FormCell>

              <TextInput
                label={'to'}
                onChange={payeeOnChange}
                placeholder="Payee"
                value={payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />

              <DateInput
                label="Paid Through"
                value={toDate ? `${toDate.year}-${toDate.month}-${toDate.date}` : null}
                name="date_to"
                onBlur={this.onBlurEvent}
                onChange={paidThroughOnChange}
                readOnly={!hasEditPermissions}
              />
            </div>
          </ItemMetaDataModal>
        </SharedItemCells>
      </div>
    );
  }

  private onBlurEvent = (event: React.FocusEvent) => {
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
  };

  private onModalToggleEvent = (expanded: boolean) => this.setState({ expanded });
}
